// extracted by mini-css-extract-plugin
export default {"profile_buttons":"profilePage_profile_buttons__CBzFv","documents":"profilePage_documents__Quycj"};